
import React, { Component } from 'react';

import { FormContext } from 'core/FormProvider';
import { ContextWidget } from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import { CheckboxWidget } from 'form/Checkbox';
import { DateWidget } from 'form/new/DateWidget';
import FormGroup from 'form/FormGroup';
import { Grid } from 'ui/Grid';


function FormDateWidget({ onChange, ...props }) {
  return <DateWidget {...props} onChange={(value, stringValue) => onChange(stringValue)} />;
}


export class DriverForm extends Component {

  render() {
    return (
      <FormContext.Consumer>
        {() => {
          return (
            <FormGroup>
              <div className={'mb-15'}>
                <ContextWidget
                  name={'is_fired'}
                  WidgetComponent={CheckboxWidget}
                  widgetProps={{
                    label: 'Уволен'
                  }}
                />
              </div>
              <ContextWidget
                name={'last_name'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Фамилия',
                  required: true
                }}
              />
              <Grid columns={'1fr 1fr'}>
                <ContextWidget
                  name={'first_name'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Имя',
                    required: true
                  }}
                />
                <ContextWidget
                  name={'middle_name'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Отчество'
                  }}
                />
              </Grid>
              <ContextWidget
                name={'birthday'}
                WidgetComponent={FormDateWidget}
                widgetProps={{
                  label: 'Дата рождения'
                }}
              />
              <Grid columns={'1fr 1fr'}>
                <ContextWidget
                  name={'phone_work'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Рабочий телефон'
                  }}
                />
                <ContextWidget
                  name={'phone_personal'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Домашний телефон'
                  }}
                />
              </Grid>
              <h3>Паспорт</h3>
              <Grid columns={'1fr 1fr'}>
                <ContextWidget
                  name={'passport_series'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Серия паспорта'
                  }}
                />
                <ContextWidget
                  name={'passport_number'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Номер паспорта'
                  }}
                />
              </Grid>
              <Grid columns={'1fr 1fr'}>
                <ContextWidget
                  name={'passport_date'}
                  WidgetComponent={FormDateWidget}
                  widgetProps={{
                    label: 'Дата выдачи паспорта'
                  }}
                />
                <ContextWidget
                  name={'passport_code'}
                  WidgetComponent={InputWidget}
                  widgetProps={{
                    label: 'Код подразделения'
                  }}
                />
              </Grid>
              <ContextWidget
                name={'passport_text'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Кем выдан',
                  multiline: true
                }}
              />
              <ContextWidget
                name={'passport_birth_place'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Место рождения'
                }}
              />
              <ContextWidget
                name={'passport_address'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Адрес прописки'
                }}
              />
              <h3>Водительское удостоверение</h3>
              <ContextWidget
                name={'driver_licence_number'}
                WidgetComponent={InputWidget}
                widgetProps={{
                  label: 'Номер водительского удостоверения'
                }}
              />
              <Grid columns={'1fr 1fr'}>
                <ContextWidget
                  name={'driver_licence_issue_date'}
                  WidgetComponent={FormDateWidget}
                  widgetProps={{
                    label: 'Дата выдачи ВУ'
                  }}
                />
                <ContextWidget
                  name={'driver_licence_expired_date'}
                  WidgetComponent={FormDateWidget}
                  widgetProps={{
                    label: 'Срок действия ВУ'
                  }}
                />
              </Grid>
            </FormGroup>
          )
        }}
      </FormContext.Consumer>
    )
  }
}
